'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  button: {
    archive: 'Archiver',
    cancel: 'Annuler',
    destroy: 'Supprimer',
    hide: 'Cacher',
    login: 'Connexion',
    show: 'Afficher'
  },
  contactInformation: {
    contactInfo: 'Informations de contact',
    copyOrganizationInfo: "Copier les informations de l'organisation",
    email: 'Courriel',
    name: 'Nom',
    specifyProtocol: 'Toujours spécifier http:// ou https:// .',
    telephone: 'Téléphone',
    website: 'Site Web'
  },
  errors: {
    403: 'Permission refusée.',
    405: 'Requête invalide.',
    422: 'Certains champs sont invalides. Veuillez remplir les informations incorrectes ou manquantes et réessayer.',
    500: 'Erreur système.'
  },
  eventsBox: {
    add: 'Ajouter',
    events: 'Événements',
    selectPlaceholder: "Saisir le titre d'un événement pour l’ajouter"
  },
  form: {
    save: 'Enregistrer',
    dontSave: 'Ne pas enregistrer'
  },
  happiness: {
    help: 'Niveau des champs obligatoires',
    title: 'Bonheur de l’événement'
  },
  imageBox: {
    credits: 'Crédits photo',
    description: 'Description',
    image: 'Image',
    title: 'Titre',
    uploadImageTypePngOrJpg: 'Veuillez uploader une image de type jpeg ou png',
    uploadSmallerFile: 'Veuillez uploader une image de 8mb ou moins'
  },
  calendarFormOptionsBox: {
    audiences: 'Publics',
    hide: 'Cacher',
    media: 'Images',
    multipleMedia: 'Plusieurs images',
    show: 'Afficher',
    singleMedia: 'Une seule image',
    taxonomies: 'Taxonomies',
    title: 'Configuration du formulaire',
    groups: 'Groupes',
    tags: 'Mots-clés',
    organization: 'Organisation',
    contactInformation: 'Information de contact'
  },
  integrationJsBox: {
    hide: 'Cacher',
    markupLabel: 'Balises HTML',
    replacements: 'Remplacements disponibles : {foreach $events}{/foreach}', // TODO
    show: 'Afficher',
    styleLabel: 'Feuille de style (CSS)',
    title: 'Intégration Javascript'
  },
  loading: 'Chargement…',
  mediaBox: {
    credits: 'Légende ou crédit photo',
    description: 'Description',
    pleaseUploadSmallerFile: 'Veuillez téléverser une image de 5 Mo ou moins.',
    title: 'Titre',
    uploadAnImage: 'Ajouter une image',
    uploadAnotherImage: 'Ajouter une autre image'
  },
  navigation: {
    account: 'Compte',
    all_events: 'Tous les événements',
    calendars: 'Calendriers',
    guide: 'Guide d’utilisation',
    logout: 'Déconnexion',
    manage: 'Gestion',
    notifications: 'Notifications',
    organizations: 'Organisations',
    taxonomies: 'Taxonomies',
    users: 'Utilisateurs',
    venues: 'Lieux'
  },
  oembed: {
    error: {
      501: 'Lien non supporté'
    }
  },
  orderPick: {
    asc: 'croissant',
    desc: 'décroissant',
    orderBy: 'en ordre'
  },
  organizationBox: {
    noneSelected: 'Aucune',
    title: 'Organisation'
  },
  pager: {
    next: 'Suivant',
    prev: 'Précédent'
  },
  regionBox: {
    title: 'Région'
  },
  roles: {
    super_admin: 'Super-Administrateur',
    admin: 'Administrateur',
    editor: 'Éditeur',
    contributor: 'Contributeur',
    guest: 'Invité',
    none: 'Aucun'
  },
  scopeSelector: {
    all: 'Tous les contextes',
    calendars: 'Calendriers',
    organizations: 'Organisations'
  },
  simpleSelect: {
    noResults: 'Aucun résultat',
    typeSome: 'Tapez pour lancer la recherche...',
    select: 'Sélectionner...'
  },
  snackbar: {
    accountUpdated: 'Votre compte a été mis à jour.',
    cantDestroyOrganization: "Impossible de supprimer cette organisation. Assurez-vous qu'elle n'est pas référencée par d'autres organisations ou calendriers.",
    eventDestroyed: '%{title} supprimé avec succès',
    eventUnlinked: '%{title} retiré du calendrier %{calendar} avec succès',
    notification: {
      archived: 'Notification archivée.',
      destroyed: 'Notification supprimée.'
    },
    organizationDestroyed: '%{title} supprimé avec succès',
    termDestroyed: '%{title} supprimé avec succès',
    userDestroyed: '%{name} supprimé avec succès',
    userUninvited: 'Accès de l\'utilisateur révoqués.',
    venueDestroyed: '%{title} supprimé avec succès',
    undo: 'Restaurer'
  },
  userRoleSelector: {
    add: 'Ajouter',
    addUser: 'Ajouter un utilisateur',
    as: 'en tant que',
    help: "Sélectionnez l'utilisateur et le rôle",
    hideInheritedRights: 'Cacher les droits hérités',
    selectRole: 'Sélectionnez un rôle',
    selectUser: 'Sélectionnez un utilisateur',
    label: 'Rôles des utilisateurs',
    members: 'Membres',
    on: 'sur',
    role: 'Rôle',
    selectPlaceholder: 'Nom ou adresse courriel',
    showInheritedRights: 'Afficher les droits hérités',
    user: 'Utilisateur'
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr/app.js
// module id = 994
// module chunks = 0